import Head from "next/head";
import { siteName, titleTail } from "@Constants/meta";
import { COMMERCE_TOOLS_DOMAINS } from "@Constants/url";

interface IMetaHeadProps {
  headTitle: string;
  headDescription: string;
  headTitleTail?: string;
}

export function MetaHead(props: IMetaHeadProps) {
  const {
    headTitle = "",
    headDescription = "",
    headTitleTail = titleTail,
  } = props;
  const fullTitle = headTitle + headTitleTail;
  const href =
    typeof window === "object"
      ? window.location.href
      : COMMERCE_TOOLS_DOMAINS.PROD.ORIGINAL;

  return (
    <Head>
      <title>{fullTitle}</title>
      <meta name="description" content={headDescription} />
      <meta
        name="viewport"
        content="width=device-width, height=device-height, initial-scale=1, minimum-scale=1, maximum-scale=1"
      />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:url" content={href} />
      <meta name="og: title" content={headTitle} />
      <meta name="og:type" content="website" />
      <meta name="og:description" content={headDescription} />
    </Head>
  );
}

export default MetaHead;
